import { Link, useParams } from "react-router-dom";
import { Layout } from "../components/layout/Layout";
import { ArticleCard } from "../components/posts/ArticleCard";
import { JsonLd } from "../components/seo/JsonLd";
import { SEO } from "../components/seo/SEO";
import { breadcrumbSchema, collectionPageSchema } from "../components/seo/schema";
import { site } from "../data/site";
import { getTag } from "../lib/taxonomy";
import { NotFound } from "./NotFound";

export function TagPage() {
  const { slug = "" } = useParams();
  const tag = getTag(slug);

  if (!tag) return <NotFound />;

  const title = `${tag.name} Tag - ${site.name}`;
  const description = `Browse ${tag.count} published yawiki.org articles tagged ${tag.name}.`;
  const canonical = `${site.url}/tag/${tag.slug}`;

  return (
    <Layout>
      <SEO title={title} description={description} canonical={canonical} />
      <JsonLd
        data={[
          collectionPageSchema(title, description, `/tag/${tag.slug}`, tag.posts.map((post) => post.url)),
          breadcrumbSchema([
            { name: "Home", url: "/" },
            { name: tag.name, url: `/tag/${tag.slug}` }
          ])
        ]}
      />
      <nav className="breadcrumbs" aria-label="Breadcrumbs">
        <Link to="/">Home</Link>
        <span>/</span>
        <span>{tag.name}</span>
      </nav>
      <header className="page-header">
        <p className="eyebrow">Tag</p>
        <h1>{tag.name}</h1>
        <p>{description}</p>
      </header>
      <div className="article-list">
        {tag.posts.map((post) => (
          <ArticleCard key={post.slug} post={post} />
        ))}
      </div>
    </Layout>
  );
}
